<template>
  <div>
    <CandidateInterviewVirtualBlank
      v-if="!candidateInterview || isOnlineInterviewBlank"
      :candidate="candidate"
    />
    <CandidateInterviewRecording v-else-if="isOnlineInterviewRecording" />
    <CandidateInterviewProcessing v-else-if="isOnlineInterviewProcessing" />
    <CandidateInterviewProcessingFailed v-else-if="isOnlineInterviewProcessingFailed" />
    <template v-else-if="candidateInterview.opened">
      <template v-if="candidate.quotaWrittenOff">
        <CandidateInterviewVirtual
          :candidate="candidate"
          :vacancy="vacancy"
          :are-questions-equal="areQuestionsEqual"
          @expanded="$emit('expanded', $event)"
          @play.once="$emit('online-interview-played')"
        />
      </template>
      <template v-else>
        <InterviewsQuotaExceededCandidate :img="poster.url">
          <AppWithLoading :fetch="openCurrentCandidate">
            <CandidateInterviewVirtual
              :candidate="candidate"
              :vacancy="vacancy"
              :are-questions-equal="areQuestionsEqual"
              @expanded="$emit('expanded', $event)"
              @play.once="$emit('online-interview-played')"
            />
          </AppWithLoading>
        </InterviewsQuotaExceededCandidate>
      </template>
    </template>
    <template v-else-if="showVirtualInterviewPlayer && candidateInterview">
      <template v-if="candidate.quotaWrittenOff">
        <CandidateInterviewVirtual
          :candidate="candidate"
          :vacancy="vacancy"
          :are-questions-equal="areQuestionsEqual"
          @expanded="$emit('expanded', $event)"
          @play.once="$emit('online-interview-played')"
        />
      </template>
      <template v-else>
        <InterviewsQuotaExceededCandidate :img="poster.url">
          <AppWithLoading :fetch="openCurrentCandidate">
            <CandidateInterviewVirtual
              :candidate="candidate"
              :vacancy="vacancy"
              :are-questions-equal="areQuestionsEqual"
              @expanded="$emit('expanded', $event)"
              @play.once="$emit('online-interview-played')"
            />
          </AppWithLoading>
        </InterviewsQuotaExceededCandidate>
      </template>
    </template>
  </div>
</template>

<script>
import InterviewsQuotaExceededCandidate from '@/components/Payment/Quota/InterviewsQuotaExceededCandidate';
import AppWithLoading from '@/components/AppWithLoading';
import { interviewStatusType, interviewImageType } from '@/enums';
import useCandidates from '@/compositions/useCandidates';
import { toRefs } from '@vue/composition-api';
import CandidateInterviewVirtual from '../CandidateInterviewVirtual.vue';
import CandidateInterviewRecording from '../CandidateInterviewRecording.vue';
import CandidateInterviewProcessing from '../CandidateInterviewProcessing.vue';
import CandidateInterviewVirtualBlank from '../CandidateInterviewVirtualBlank.vue';
import CandidateInterviewProcessingFailed from '../CandidateInterviewProcessingFailed.vue';

export default {
  name: 'OnlineInterview',
  components: {
    AppWithLoading,
    InterviewsQuotaExceededCandidate,
    CandidateInterviewProcessingFailed,
    CandidateInterviewVirtualBlank,
    CandidateInterviewVirtual,
    CandidateInterviewRecording,
    CandidateInterviewProcessing,
  },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
    interview: {
      required: true,
    },
    areQuestionsEqual: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  setup(props) {
    const { openCandidate } = useCandidates();
    const { candidate } = toRefs(props);

    async function openCurrentCandidate() {
      await openCandidate(candidate.value?.id);
    }

    return {
      openCurrentCandidate,
    };
  },
  computed: {
    candidateInterview() {
      return this.interview?.status ? this.interview : null;
    },
    isOnlineInterviewBlank() {
      return this.candidateInterview
        && this.interview.status === interviewStatusType.BLANK;
    },
    isOnlineInterviewRecording() {
      return this.candidateInterview
        && this.interview.status === interviewStatusType.RECORDING;
    },
    isOnlineInterviewProcessing() {
      return this.candidateInterview
        && this.interview.status === interviewStatusType.PROCESSING;
    },
    isOnlineInterviewProcessingFailed() {
      return this.candidateInterview
        && this.interview.status === interviewStatusType.PROCESSING_FAILED;
    },
    showVirtualInterviewPlayer() {
      return this.candidateInterview
        && this.interview.status === interviewStatusType.READY;
    },
    poster() {
      return this.candidateInterview?.images?.find((p) => p.type === interviewImageType.H296);
    },
  },
};
</script>

<style scoped>

</style>
